<template>
  <div class="userPlans">
    <div class="btnContainer">
      <v-btn color="primary" @click="onAddNewPlan" :disabled="!isAvailableAddNewPlan" text small>
        <v-icon class="mr-2">mdi-plus</v-icon>Add new plan</v-btn
      >
    </div>
    <div v-if="loading">
      <span>
        <v-progress-circular
          indeterminate
          :size="20"
          color="blue lighten-5"
          class="mr-2"
        ></v-progress-circular
        >Loading..
      </span>
    </div>
    <div v-else-if="isPlansExists" class="planList">
      <div v-for="plan in userPlans" :key="plan.Id" class="plan">
        <div class="planName">{{ plan.Reference }}</div>
        <div class="actionBtn">
          <v-icon @click.stop="onDeletePlan(plan)" class="actionIcon">mdi-delete</v-icon>
        </div>
      </div>
    </div>
    <div v-else>No plans.</div>

    <v-dialog v-model="dialog" :width="options.width" persistent>
      <v-card>
        <v-card-title class="text-h5 lighten-2">{{ 'Add plan' }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-select
            :items="plansList"
            item-value="Id"
            item-text="ShortName"
            v-model="newUserPlansList"
            label="Select plan/s"
            multiple
            dense
            outlined
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index < maxVisible">
                {{ item.ShortName }}<span v-if="index < maxVisible - 1">, </span>
              </span>
              <span v-else-if="index === maxVisible">
                ...+{{ newUserPlansList.length - maxVisible }} more
              </span>
            </template>
          </v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text @click="onCancel"> Cancel </v-btn>
          <v-btn color="primary" @click="onSaveNewPlan"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>
<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'UserPlans',
  components: {
    Dialog,
  },
  props: {
    userName: { type: String },
    roleId: { type: Number },
    plansList: { type: Array },
  },
  
  created() {
    this.getUserPlans();
  },
  data: () => ({
    userPlans: [],
    newUserPlansList: [],
    loading: false,
    dialog: false,
    options: {
      width: 500,
    },
    maxVisible: 2,
  }),
  methods: {
    onAddNewPlan() {
      this.dialog = true;
    },
    onCancel() {
      this.dialog = false;
      this.setNewUserPlansList();
    },
    onSaveNewPlan() {
      this.addUserPlan();
    },
    async onDeletePlan(plan) {
      try {
        console.log(this.$refs);
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deletePlan(plan);
      } catch (err) {
        console.log(err);
      }
    },
    async getUserPlans() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/Roles/GetRoleUserPlans?roleId=' + this.roleId + '&userName=' + this.userName
        );
        this.userPlans = response.data;
        this.loading = false;
        this.setNewUserPlansList();
      } catch (err) {
        console.error(err);
      }
    },
    async addUserPlan() {
      try {
        const data = {
          roleId: this.roleId,
          userName: this.userName,
          plans: this.newUserPlansList,
        };
        await this.$api.post('/Roles/AddUserPlans', data);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Plan was added',
        });
        this.dialog = false;
        this.getUserPlans();
      } catch (err) {
        console.log(err.message);
      }
    },
    async deletePlan(plan) {
      try {
        await this.$api.delete(
          '/Roles/DeleteUserPlan?roleId=' +
            this.roleId +
            '&userName=' +
            this.userName +
            '&planId=' +
            plan.Id
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'The plan has been removed for the user',
        });
        this.getUserPlans();
      } catch (err) {
        console.log(err.message);
      }
    },

    setNewUserPlansList() {
      let result = [];
      if (this.plansList && this.userPlans) {
        this.plansList.forEach((x) => {
          if (this.userPlans.find((y) => y.Id == x.Id)) {
            result.push(x.Id);
          }
        });
      }
      this.newUserPlansList = result;
    },
  },
  computed: {
    isPlansExists() {
      return this.userPlans && this.userPlans.length > 0;
    },
    isAvailableAddNewPlan() {
      return this.plansList && this.plansList.length > 0;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.userPlans {
  width: 100%;
  padding: 5px;

  .btnContainer {
    display: flex;
    justify-content: right;
  }

  .planList {
    max-height: 150px;
    overflow-y: auto;
    padding: 5px 5px 5px 0px;

    .plan {
      display: flex;
      padding: 3px;
      justify-content: space-between;
      border-bottom: 1px solid lightgray;

      .planName {
        flex-basis: 200px;
        flex-grow: 3;
      }

      .actionBtn {
        flex-basis: 50px;
        flex-grow: 0;

        .actionIcon {
          font-size: 1.2rem;
          vertical-align: top;
          margin-right: 5px;
          color: #ff5252;
        }
      }
    }
  }
}
</style>
